// import Vue from 'vue'
// import App from './App.vue'

import { VueReCaptcha } from 'vue-recaptcha-v3'

// For more options see below
Vue.use(VueReCaptcha, { siteKey: '6LcBp8wUAAAAAKDJM47XjtVCIbW8hZSReZGmLh1E', loaderOptions: {
    autoHideBadge: true
  } });
import contact from './components/pages/ContactezNous'

new Vue({
  el: '#contactez-nous',
  render: h => h(contact)
});
